import React, { useEffect, useState } from 'react';
import { Select } from 'antd';
import { useRefCode } from 'hooks';
import { selectBoxFilterOption2 } from 'utils/form-utils';

export interface RefCodeSelectBox {
  fieldName: string;
  placeholder?: string;
  codeValue?: string;
  boxSize?: string;
  onChangeSelect?: (value: string) => void;
}

const RefCode = ({
  fieldName,
  placeholder,
  codeValue,
  boxSize = '150px',
  onChangeSelect
}: RefCodeSelectBox): React.ReactElement => {
    
  /* ======================================================
  * States
  * ====================================================== */
  const [options, setOptions] = useState<any[]>([]);
  const [searchValue, setSearchValue] = useState<string>('');


  /* ======================================================
  * hooks
  * ====================================================== */
  const { refCodeList } = useRefCode({field:fieldName});  

  /* ======================================================
   * effects
   * ====================================================== */

  useEffect(() => {
    const opts : any[] = [];
    opts.push({value: 'A', label: '전체'})

    if (refCodeList) {
      refCodeList.forEach((item) => {
        if (searchValue.length > 0) {
          if (item.status_type == 'AV') {
            opts.push({value: item.name, label: item.value, caption: item.value})  
          } else {
            opts.push({value: item.name, label: <span style={{color:'red'}}>{item.value}</span>, caption: item.value})  
          }
        } else if (item.status_type == 'AV') {
          opts.push({value: item.name, label: item.value, caption: item.value})  
        }
      })
    }

    setOptions(opts);
    
  }, [refCodeList, searchValue]);

  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <Select 
      style={{width:boxSize }} 
      value={codeValue}
      placeholder={placeholder}
      onSelect={onChangeSelect}
      virtual={false}
      showSearch={true} 
      options={options}       
      optionFilterProp="label" 
      searchValue={searchValue}    
      filterOption={selectBoxFilterOption2}
      onSearch={(value) => {setSearchValue(value)}}     
    /> 
  );
};

export default RefCode;
